module.exports = __webpack_public_path__ + "static/media/linkedin.f3c90c49.svg";